// Character pick — v2 language, day-0.1.
//
// "Which one are you playing?" — single-question surface, choices as quiet
// stacked text, no pills/radios. Selection = gold hairline. After picking,
// navigates to /script (script-with-callouts) directly; the analyzer pass
// is opt-in from there ("Rehearsal room" affordance).
import { useNavigate } from "react-router-dom";
import { useArc } from "../state/arc";

export default function CharacterPick() {
  const navigate = useNavigate();
  const { state, update } = useArc();

  if (!state.parsedProject) {
    return (
      <div className="v2">
        <h2>No script loaded.</h2>
        <button className="v2-affordance" onClick={() => navigate("/upload")}>← Upload</button>
      </div>
    );
  }

  const { script_name, characters } = state.parsedProject;

  return (
    <div className="v2">
      <p className="v2-tracked-caps" style={{ textAlign: "center" }}>{script_name}</p>
      <h2 style={{ textAlign: "center", marginTop: 0 }}>Which one are you playing?</h2>

      {characters.length === 0 ? (
        <p className="v2-prompt" style={{ textAlign: "center" }}>
          We didn't find any characters in this file. Try a different scene.
        </p>
      ) : (
        <ul className="v2-choices">
          {characters.map((c) => (
            <li
              key={c}
              className={state.selectedCharacter === c ? "is-selected" : ""}
              onClick={() => {
                update({ selectedCharacter: c });
                // Update the shelf entry with the chosen character.
                if (state.projectId) {
                  import("./Library").then(({ saveShelfEntry }) => {
                    saveShelfEntry({
                      projectId: state.projectId!,
                      scriptName: script_name,
                      character: c,
                      lastVisited: Date.now(),
                    });
                  });
                }
                navigate("/script");
              }}
            >
              {c}
            </li>
          ))}
        </ul>
      )}

      <hr className="v2-hairline" />
      <div style={{ display: "flex", justifyContent: "center", gap: "2.5rem", marginTop: "1.5rem" }}>
        <button className="v2-affordance" onClick={() => navigate("/upload")}>Different script</button>
      </div>
    </div>
  );
}
